import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styles from "../../assets/styles/appointments.module.css"
import { FormGroup, FormLabel, IconButton, InputAdornment, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { SearchIcon } from '../../utils/functions/Icons';
import { ChangeEvent, forwardRef } from 'react';
import Loader from '../common/Loader';
import NoDataFound from '../common/NoDataFound';
import DocumentViewModal from '../savedDocuments/DocumentViewModal';
import { CalendarIcon, ClearIcon, DatePicker } from '@mui/x-date-pickers';
import moment, { Moment } from 'moment';

interface Props {
    searchValue: string,
    loading: boolean,
    listData: EquipmentRecordTypes[] | [];
    handleSearchValue: (e: ChangeEvent<HTMLInputElement>) => void;
    handleDateChange: (value: Date | null, name: string) => void;
    filterValue: FilterTypes
}
const EquipmentTable = forwardRef<HTMLTableElement, Props>(({
    listData,
    searchValue,
    loading,
    handleSearchValue,
    handleDateChange,
    filterValue }, ref) => {
    return (
        <div>
            <div className={'mb-6 flex justify-between items-center flex-col md:flex-row w-full max-w-full gap-y-4 md:gap-y-0'}>
                <FormGroup className="customFormGroup md:w-1/2 w-full">
                    <TextField
                        className={`custumTextField ${styles.InputStyle}`}
                        id="searchValue"
                        name="searchValue"
                        value={searchValue}
                        placeholder='Search'
                        onChange={handleSearchValue}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </FormGroup>
                <div className='grid grid-cols-2 gap-6 md:w-1/3 w-full'>
                    <FormGroup className="customFormGroup">
                        <FormLabel className="customFormLabel">From</FormLabel>
                        <DatePicker
                            className="custumTextField profileInput ClearBtnDate"
                            name='fromDate'
                            value={moment(filterValue?.fromDate, 'DD-MM-YYYY')}
                            format="DD-MM-YYYY"
                            onChange={(date) => {
                                handleDateChange(date !== null ? moment(date)?.toDate() : null, 'fromDate')
                            }}
                            slotProps={{ field: { clearable: filterValue?.fromDate ? true : false } }}
                        />
                    </FormGroup>
                    <FormGroup className="customFormGroup">
                        <FormLabel className="customFormLabel">To</FormLabel>
                        <DatePicker
                            className="custumTextField profileInput ClearBtnDate"
                            name='toDate'
                            value={moment(filterValue?.toDate, 'DD-MM-YYYY')}
                            format="DD-MM-YYYY"
                            minDate={moment(filterValue?.fromDate, 'DD-MM-YYYY')}
                            onChange={(date) => {
                                handleDateChange(date !== null ? moment(date)?.toDate() : null, 'toDate')
                            }}
                            slotProps={{ field: { clearable: filterValue?.toDate ? true : false } }}
                        />
                    </FormGroup>
                </div>
            </div>
            {
                loading ? <Loader />
                    :
                    <TableContainer component={Paper} className='TableContainer'>
                        <Table ref={ref} sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead className='custumTableHead'>
                                <TableRow>
                                    <TableCell className='whitespace-nowrap'>Sr No.</TableCell>
                                    <TableCell className='whitespace-nowrap'>Date</TableCell>
                                    <TableCell className='whitespace-nowrap'>Total Quantity</TableCell>
                                    <TableCell className='whitespace-nowrap'>Newly Added</TableCell>
                                    <TableCell className='whitespace-nowrap'>Discarded</TableCell>
                                </TableRow>
                            </TableHead>
                            {
                                listData?.length > 0 ?
                                    <TableBody>
                                        {
                                            listData?.map((item, index) => {
                                                return (
                                                    <TableRow
                                                        key={index}
                                                        className='custumTableRow'
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="td" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell component="td" scope="row">
                                                            {item?.date}
                                                        </TableCell>
                                                        <TableCell component="td" scope="row">
                                                            {item?.totalQuantitySum}
                                                        </TableCell>
                                                        <TableCell component="td" scope="row">
                                                            {item?.newlyAddedSum}
                                                        </TableCell>
                                                        <TableCell component="td" scope="row">
                                                            {item?.discardedSum}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }

                                    </TableBody>
                                    :
                                    <TableBody>
                                        <TableRow
                                            className='custumTableRow'
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row" colSpan={5}>
                                                <NoDataFound />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                            }
                        </Table>
                    </TableContainer>
            }
            <DocumentViewModal />
        </div>
    );
});

export default EquipmentTable